import * as React from "react";
import { Container, Stack, Grid } from "@mui/material";

import { useSetRecoilState } from "recoil";
import { getValueOnBreakpoint } from "../../../lib/getValueOnBreakpoint";
import { clickHandler } from "../../../lib/clickHandler";
import { XElementConfig } from "../../../utils/interfaces/Elements/XElement.interfaces";

import { isEqual } from "lodash";
import { generateSide } from "../../../lib/generateSide";

import {
  IXProductDetailsProps,
  XProductDetailsProps,
} from "../../../utils/interfaces/containers/XProductDetails.interfaces";
// import { useSortable } from "@dnd-kit/sortable";
// import { CSS } from "@dnd-kit/utilities";
import { useBreakpoint } from "../../../hooks/useBreakpoint";
import { TSetUrlParamsArgs, useXoraiaValue } from "../../../hooks/useXoraia";
import { TUseXElement, useXElement } from "../../../hooks/useXElement";
import { USE_SELECTED_INDEX } from "../../../hooks/useSelectedElement";
// import { Grid } from "../../core/Grid";
import ProductDetailsPreview from "./ProductDetailsPreview";
import ProductDetailsInfo from "./ProductDetailsInfo";
import { generateArticleData } from "../../../lib/generateArticleData";

const compareProps = (prevProps: any, nextProps: any) => {
  return isEqual(prevProps, nextProps);
};

const XProductDetails: React.FC<XProductDetailsProps> = React.memo(
  ({ config = {} as XElementConfig }) => {
    const [urlParams, updateUrlParams] = React.useState<TSetUrlParamsArgs>({});

    // WE TRACK THE BREAK POINTS CHANGES
    const breakpoint = useBreakpoint();

    const { env, article } = useXoraiaValue();

    // WE ARE GETTING THE CURRENT ELEMENT FROM THE ATOM FAMILY
    const { xElement } = useXElement<TUseXElement<IXProductDetailsProps>>(
      config.index
    );

    const onChange = async (args: TSetUrlParamsArgs) => {
      try {
        updateUrlParams((old) => ({ ...old, ...args }));
      } catch (error) {
        console.error("UPDATE_URL =>", error);
      }
    };

    // GARBING THE INDEX UPDATER FOR GENERAL USAGE
    const setSelectedElement = useSetRecoilState(USE_SELECTED_INDEX);

    // IF WE DONT HAVE THIS ELEMENT CONFIGS ADDED WE DON'T SHOW IT
    if (!xElement || Object.keys(xElement).length === 0) return null;

    // WE GET ALL DEVICES PROPS AS VALUE
    const { value } = xElement;

    // WE NOW USE THE CURRENT BREAKPOINT VALUE ON THIS ELEMENT
    const valueAtBreakPoint = getValueOnBreakpoint<IXProductDetailsProps>(
      value as any,
      breakpoint
    );

    const devProps = {
      id: config.index,
      onClick: (e: any) => clickHandler(e, setSelectedElement, config.index),
      // ...(!xElement.childOf && dndProps),
    };

    const {
      containerMode = "CENTER",
      previewPosition = "left",
      padding = {},
      margin = {},
    } = valueAtBreakPoint;

    const _article = env !== "prod" ? generateArticleData(1)[0] : article;

    if (!_article) return null;

    const previewSide = (
      <ProductDetailsPreview
        {...valueAtBreakPoint}
        article={_article}
        urlParams={urlParams}
      />
    );

    const detailsSide = (
      <ProductDetailsInfo
        {...valueAtBreakPoint}
        article={_article}
        urlParams={urlParams}
        onChange={onChange}
      />
    );

    let grid = (
      <Grid container spacing={4} position="relative">
        {previewPosition !== "right" ? previewSide : detailsSide}
        {previewPosition !== "right" ? detailsSide : previewSide}
      </Grid>
    );

    if (containerMode === "CENTER") {
      grid = <Container>{grid}</Container>;
    } else if (containerMode === "FILL") {
      grid = <Container maxWidth={false}>{grid}</Container>;
    }

    return (
      <Stack
        position="relative"
        {...(env === "dev" && devProps)}
        width="100%"
        sx={{
          margin: generateSide("margin", margin),
          padding: generateSide("padding", padding),
        }}
      >
        {grid}
      </Stack>
    );
  },
  compareProps
);

export default XProductDetails;
